import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "M3.23891 4.17555C0.995557 6.4189 0.995559 10.0561 3.23891 12.2995L11.9402 21.0007L12 20.9409L12.0599 21.0008L20.7611 12.2995C23.0045 10.0562 23.0045 6.41897 20.7611 4.17562C18.5177 1.93227 14.8805 1.93227 12.6372 4.17562L12.3536 4.45923C12.1583 4.65449 11.8417 4.65449 11.6465 4.45923L11.3628 4.17555C9.11946 1.9322 5.48226 1.9322 3.23891 4.17555Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "heart"}) } }